import {AppThunk} from '../index';
import {snackbarSlice} from '../../reducers/snackbar';
import {SnackbarNotification, SnackbarNotificationBase} from '../../../shared/components/snackbar/model';
import {newGuid} from '../../../shared/pipes';

export const setNotifications = snackbarSlice.actions.setNotifications;

const baseNotificationDuration = 3000;

export const addNotification = (notificationCreator: SnackbarNotificationBase): AppThunk => {
  return async (dispatch, getState) => {
    const state = getState();
    const existingNotifications = state.snackbar.notifications;
    if (existingNotifications.some((item) => item.message === notificationCreator.message)) {
      return;
    }
    const notifications: SnackbarNotification[] = [
      {
        duration: baseNotificationDuration,
        ...notificationCreator,
        id: newGuid(),
      },
      ...existingNotifications,
    ];
    dispatch(setNotifications(notifications));
  };
};

export const removeNotification = (id: string): AppThunk => {
  return async (dispatch, getState) => {
    const state = getState();
    const notifications: SnackbarNotification[] = state.snackbar.notifications.filter((item) => item.id !== id);
    dispatch(setNotifications(notifications));
  };
};
